(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-archive-collection-form]').forEach((form) => {
      if (form.dataset.archiveReady) return;
      const panel = form.querySelector('[data-archive-filter-panel]');
      const toggle = form.querySelector('[data-archive-filter-toggle]');
      const page = form.closest('.collection-page');
      if (!panel || !page) return;
      form.dataset.archiveReady = 'true';
      const expanded = Number(page.dataset.activeFilterCount || 0) > 0;
      panel.hidden = !expanded;
      if (toggle) {
        toggle.hidden = false;
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.addEventListener('click', () => {
          panel.hidden = !panel.hidden;
          toggle.setAttribute('aria-expanded', String(!panel.hidden));
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          panel.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.focus();
        });
      }
      form.querySelector('[name="sort_by"]')?.addEventListener('change', () => form.requestSubmit());
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
